import { isNullOrEmptyArray } from './general';

// Calculate unique values for a column
export const calculateUniqueValues = (data, columnId) => {
  if (!data || !data.length) return [];
  return [...new Set(data.map(row => row[columnId] === '' || row[columnId] == null ? '(None)' : row[columnId]))];
};

// Calculate unique values for all columns
export const calculateAllUniqueValues = (data, columns) => {
  if (!data || !data.length || !columns) return {};
  const result = {};
  columns.forEach(col => {
    const colId = typeof col === 'string' ? col : col.id;
    result[colId] = calculateUniqueValues(data, colId);
  });
  return result;
};

// Apply filters to data
export const applyFilters = (data, filters, columnFilters) => {
  if (isNullOrEmptyArray(data)) return [];
  
  let result = data;
  const keys = Object.keys(data[0]);

  // Apply text input filters
  keys.forEach(key => {
    if (filters[key] && filters[key].length > 0) {
      result = result.filter(r => r[key] && r[key].toLowerCase().indexOf(filters[key].toLowerCase()) > -1);
    }
  });

  // Apply advanced filters from FilterIcon
  keys.forEach(key => {
    const filter = columnFilters[key];
    if (!filter) return;

    // Text filter
    if (filter.textFilter && filter.textFilter.type && filter.textFilter.value) {
      result = result.filter(row => (row[key] || '').toString().toLowerCase().includes(filter.textFilter.value.toLowerCase()));
    }

    // Checkbox filter
    if (filter.checkboxFilters && filter.checkboxFilters.length > 0) {
      result = result.filter(row => {
        const cellValue = row[key];
        const normalized = cellValue === '' || cellValue == null ? '(None)' : cellValue;
        return filter.checkboxFilters.includes(normalized);
      });
    }
  });

  return result;
};

// Initialize filters for columns
export const initializeFilters = (columns) => {
  const filters = {};
  columns.forEach(column => {
    filters[column] = '';
  });
  return filters;
}; 